'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGTranslate = function MdGTranslate(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 33.4v-21.8c0-0.9-0.7-1.6-1.6-1.6h-14.7l1.9 6.7h3.2v-1.7h1.8v1.7h6v1.7h-2.1c-0.5 2.1-1.7 4.2-3.2 5.9l4.6 4.4-1.2 1.3-4.5-4.5-1.5 1.5 1.3 4.6-3.4 3.4h11.8c0.9 0 1.6-0.7 1.6-1.6z m-11.7-13.2c0.4 0.8 1 1.8 1.9 2.9 2-2.5 2.5-4.7 2.5-4.7h-6.6l0.5 1.8h1.7z m-1.3 1.3l1 3.7 1-0.9c-0.8-0.9-1.4-1.8-2-2.8z m-3.5-3.8c0-0.4 0-0.9-0.1-1.2h-6.6v2.6h3.7c-0.3 1-1.3 2.5-3.6 2.5-2.1 0-3.9-1.9-3.9-4.1s1.8-4.1 3.9-4.1c1.3 0 2.1 0.6 2.5 1.1l0.2 0 2-1.9-0.1-0.1c-1.3-1.2-2.8-1.8-4.6-1.8-3.7 0-6.7 3.1-6.7 6.8s3 6.8 6.8 6.8c3.8 0 6.5-2.7 6.5-6.6z m14.9-9.3c1.8 0 3.2 1.4 3.2 3.2v21.8c0 1.8-1.4 3.2-3.2 3.2h-13.4l-1.6-5h-11.8c-1.8 0-3.2-1.4-3.2-3.2v-21.8c0-1.8 1.4-3.2 3.2-3.2h10l1.5 5h15.3z' })
        )
    );
};

exports.default = MdGTranslate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/g-translate.js
// module id = 794
// module chunks = 0